import { Component, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { BeneListService } from '../../services/beneList.service';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
})
export class ModalComponent {
  @Input() dismiss;

  constructor(private beneListService: BeneListService, public modalService: ModalService) {}

  cancel() {
    this.modalService.showModal = false;
    this.beneListService.resetInit();
    this.beneListService.reset();
    this.dismiss();

    if (document.querySelector('body').classList.contains('modal-container__fullpage')) {
      document.querySelector('body').classList.remove('modal-container__fullpage');
    }
  }
}
